var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddInvestmentsCompanies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 18V18.5H2H8.5V19.5H2C1.18069 19.5 0.5 18.8193 0.5 18V2C0.5 1.18069 1.18069 0.5 2 0.5H9.79289L15.5 6.20711V11.5H14.5V7V6.5H14H9.5V2V1.5H9H2H1.5V2V18ZM8.35355 12.9395L11.293 10.0001L11.9999 10.707L8 14.707L6.35355 13.0605L6 12.707L5.64645 13.0605L4.70703 13.9999L4.00008 13.293L6 11.293L7.64645 12.9395L8 13.293L8.35355 12.9395ZM14 17.5H14.5V17V14.5H15.5V17V17.5H16H18.5V18.5H16H15.5V19V21.5H14.5V19V18.5H14H11.5V17.5H14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddInvestmentsCompanies);
export default __webpack_public_path__ + "static/media/add-investments-companies.5b43a14adad38c203779986ab8fd950a.svg";
export { ForwardRef as ReactComponent };